<script>

	import { onMount } from 'svelte';

	import Modal from './Modal.svelte';

	import { modal, bigError, busy, settings } from '../lib/stores.js';
	import { isDesktop } from '../lib/device.js';
	import { componentWindow } from '../lib/componentWindow.js';

	export let mounted = true;

	onMount(() => {

		let opts;

		if (mounted) {
			opts = [
				{
					name: "Dismiss",
					display: {
						mini: true,
						ghost: true
					},
					f: () => { $bigError = null; $busy = false; }
				},
			];
		}

		$modal = {
			message: 'Sorry, there was a problem.',
			details: [$bigError],
			opts: opts
		};

	});

</script>

<Modal/>